module.exports = {"pipeline":{"name":"pipeline-sequenceQuestion","title":"排序题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-sequenceQuestion/package.json
// module id = 285
// module chunks = 1